// Resolves which surface this bundle is running on.
//   "web"      — default, served from Cloudflare Pages
//   "canvas"   — Capacitor-wrapped customer storefront (iOS + Android)
//   "business" — Capacitor-wrapped business dashboard (iOS + Android)
//
// VITE_APP_MODE is baked in at build time via vite.config.ts `define`.
// IS_NATIVE is a runtime check — `true` only inside a Capacitor WebView.

import { Capacitor } from "@capacitor/core";

export type AppMode = "web" | "canvas" | "business";

const rawMode = (import.meta.env.VITE_APP_MODE ?? "web") as string;
export const APP_MODE: AppMode =
  rawMode === "canvas" || rawMode === "business" ? rawMode : "web";

export const isCanvas = () => APP_MODE === "canvas";
export const isBusiness = () => APP_MODE === "business";
export const isWeb = () => APP_MODE === "web";

export const IS_NATIVE: boolean = Capacitor.isNativePlatform();
export const NATIVE_PLATFORM: "ios" | "android" | "web" =
  Capacitor.getPlatform() as "ios" | "android" | "web";
